var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"clss":"vx-row mb-12"}},[_c('data-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }